import { useQuery } from 'react-query';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { generatePassword } from 'src/services/napi/users/generatePassword';
import { useNotification } from '../../../providers/notificationsProvider';

const getGeneratedPassword = async () => {
  const currentProject = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject) return;
  const { _id: projectId } = currentProject;
  const response = await generatePassword(projectId);

  return response?.data?.generatedPassword;
};

export const useGetGeneratedPassword = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.GENERATE_USER_PASSWORD], () => getGeneratedPassword(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
